import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-598b6fc1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-select-picker" }
const _hoisted_2 = ["id", "value", "placeholder", "required", "readonly", "disabled"]
const _hoisted_3 = { class: "selection" }

import { computed, onMounted, PropType, ref, watch } from 'vue'
// import {
//   DigInputSelectableElement,
//   DigInputSelection,
// } from '@digithia/input/common'
import { getUUID } from '@/common/Utils'

interface BaseSelectOption {
  value: string | number
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSelectPicker',
  props: {
  name: { type: String },
  value: { type: [String, Number] as PropType<string | number | undefined> },
  required: { type: Boolean, default: false },
  maxShown: { type: Number, default: 5 },
  enableFreeValue: { type: Boolean, default: false },
  placeholder: { type: String },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  options: {
    type: Array as PropType<BaseSelectOption[]>,
    required: true,
  },
},
  emits: ["select"],
  setup(__props, { emit: emits }: { emit: ({
  (event: 'select', value: string | number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const id = ref(getUUID())
const toggled = ref(false)
const touched = ref(false)
const focused = ref(false)
const belowSelection = ref(true)
const inputValue = ref('')

const selectionEl = ref<undefined | any>()
const inputEl = ref<undefined | HTMLInputElement>()
const digInputFieldEl = ref<undefined | HTMLElement>()
const slotEl = ref<undefined | HTMLSlotElement>()

const showValidity = computed(() => {
  return (!!props.value || touched) && !props.disabled && !props.readonly
})

const valid = computed(() => props.value)
const invalid = computed(() => !props.value && props.readonly)

onMounted(() => {
  if (!props.value) return
  watchModel()
})

const isMobile = (): boolean => {
  return !!(
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
    (navigator.userAgent.match(/Mac/) &&
      navigator.maxTouchPoints &&
      navigator.maxTouchPoints > 2)
  )
}

const openSelection = () => {
  selectionEl.value?.open(`${props.value || ''}`)
  toggled.value = true
  focused.value = true
  touched.value = true
  if (!isMobile()) {
    inputEl.value?.focus()
  }
  setTimeout(() => {
    document.addEventListener('click', closeSelection)
    belowSelection.value =
      window.innerHeight -
        (digInputFieldEl.value?.getBoundingClientRect().bottom || 0) >
      (selectionEl.value?.clientHeight || 0)
  })
}

const closeSelection = (event: MouseEvent) => {
  selectionEl.value?.close()
  focused.value = false
  toggled.value = false
  document.removeEventListener('click', closeSelection)
}

const handleInput = (event: Event) => {
  const target = event.target as HTMLInputElement
  inputValue.value = target.value || ''
  if (props.enableFreeValue) {
    emits('select', target.value)
  } else {
    const option = props.options.find(
      (o) =>
        target.value &&
        (o.label === target.value || `${o.value}` === target.value),
    )
    if (option) {
      emits('select', option.value)
    } else {
      emits('select', '')
    }
  }
  selectionEl.value?.search(inputValue.value)
}

const itemSelected = (event: CustomEvent): void => {
  inputValue.value = event.detail?.label || event.detail?.innerText || ''
  emits('select', event.detail?.value || '')
  focused.value = false
}

const focusSearchInput = (): void => {
  if (!focused.value) {
    openSelection()
  }
}

const handleKeyUp = (event: KeyboardEvent) => {
  if (event.key === 'ArrowDown') {
    selectionEl.value?.goDown()
  } else if (event.key === 'ArrowUp') {
    selectionEl.value?.goUp()
  } else if (event.key === 'Enter') {
    if (!props.value) {
      selectionEl.value?.validateSelection()
    }
    selectionEl.value?.close()
    toggled.value = false
  } else if (event.key === 'Escape') {
    selectionEl.value?.close()
    toggled.value = false
    document.removeEventListener('click', closeSelection)
  } else if (event.key === 'Tab') {
    openSelection()
  }
}

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === 'Tab') {
    selectionEl.value?.close()
    focused.value = false
    toggled.value = false
    document.removeEventListener('click', closeSelection)
  }
}

const reset = (): void => {
  touched.value = false
  emits('select', '')
  inputValue.value = ''
}

const checkValidity = (): boolean => {
  touched.value = true
  return getValidity()
}

const getValidity = (): boolean => {
  return !props.required || !!props.value
}

watch(
  () => props.value,
  () => {
    watchModel()
  },
)

const watchModel = () => {
  if (props.enableFreeValue) {
    inputValue.value = `${props.value || ''}`
  } else {
    const option = props.options.find(
      (o) =>
        props.value && (o.label === props.value || o.value === props.value),
    )
    if (option) {
      inputValue.value = option.label || `${option.value}`
    } else if (props.value !== '') {
      emits('select', '')
      inputValue.value = ''
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_dig_input_label = _resolveComponent("dig-input-label")!
  const _component_dig_input_close = _resolveComponent("dig-input-close")!
  const _component_dig_input_arrow = _resolveComponent("dig-input-arrow")!
  const _component_dig_input_field = _resolveComponent("dig-input-field")!
  const _component_dig_input_selection = _resolveComponent("dig-input-selection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dig_input_field, {
      ref_key: "digInputFieldEl",
      ref: digInputFieldEl,
      class: _normalizeClass(["dig-input-select-picker", {
        disabled: __props.disabled || __props.readonly,
      }]),
      "show-validity": _unref(showValidity),
      valid: _unref(valid),
      invalid: _unref(invalid),
      focused: focused.value,
      onClick: _cache[5] || (_cache[5] = ($event: any) => (openSelection()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("input", {
          ref_key: "inputEl",
          ref: inputEl,
          class: _normalizeClass(["dig-input-select-picker-search", {
          disabled: __props.disabled || __props.readonly,
          'cannot-be-focused': !toggled.value,
        }]),
          type: "text",
          id: id.value,
          value: inputValue.value,
          placeholder: 
          __props.disabled || __props.readonly || !focused.value ? '' : __props.placeholder || 'Rechercher'
        ,
          required: __props.required,
          readonly: __props.readonly,
          disabled: __props.disabled,
          size: "5",
          autocomplete: "off",
          onKeyup: _cache[0] || (_cache[0] = ($event: any) => (handleKeyUp($event))),
          onKeydown: _cache[1] || (_cache[1] = ($event: any) => (handleKeyDown($event))),
          onInput: _cache[2] || (_cache[2] = ($event: any) => (handleInput($event))),
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (focusSearchInput()))
        }, null, 42, _hoisted_2),
        _createVNode(_component_dig_input_label, {
          asterisk: __props.required,
          active: __props.value || focused.value,
          transparent: (__props.disabled || __props.readonly) && !__props.value
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "label")
          ]),
          _: 3
        }, 8, ["asterisk", "active", "transparent"]),
        _createVNode(_component_dig_input_close, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (reset())),
          hidden: (focused.value && __props.value) || __props.required
        }, null, 8, ["hidden"]),
        _createVNode(_component_dig_input_arrow, { toggled: toggled.value }, null, 8, ["toggled"])
      ]),
      _: 3
    }, 8, ["class", "show-validity", "valid", "invalid", "focused"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_dig_input_selection, {
        ref_key: "selectionEl",
        ref: selectionEl,
        class: _normalizeClass({
          below: belowSelection.value,
          above: !belowSelection.value,
        }),
        toggled: toggled.value,
        "max-shown": __props.maxShown,
        onValidate: _cache[6] || (_cache[6] = ($event: any) => (itemSelected($event)))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "options", {
            ref_key: "slotEl",
            ref: slotEl
          })
        ]),
        _: 3
      }, 8, ["class", "toggled", "max-shown"])
    ])
  ]))
}
}

})